/**
 * The console's clock-based shift windows, shared by the shift footer and
 * the header's shift pill. Fixed local clock times — LicenseProfile.openingHours
 * is free text and can't be parsed reliably into boundaries.
 */
export type Shift = 'lunch' | 'snack' | 'dinner';

export const SHIFT_ORDER: Shift[] = ['lunch', 'snack', 'dinner'];

export const SHIFT_LABEL: Record<Shift, string> = {
  lunch: 'Lunch',
  snack: 'Snack',
  dinner: 'Dinner',
};

/** 24-hour local boundaries. */
export const SNACK_START_HOUR = 16;
export const DINNER_START_HOUR = 19;

export function shiftAt(millis: number): Shift {
  const hour = new Date(millis).getHours();
  if (hour < SNACK_START_HOUR) return 'lunch';
  if (hour < DINNER_START_HOUR) return 'snack';
  return 'dinner';
}

/** Local midnight of the day containing `millis`. */
export function startOfDay(millis: number): number {
  const d = new Date(millis);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/** A shift's own [start, end) on the day containing `millis`. */
export function shiftRange(shift: Shift, millis: number): { start: number; end: number } {
  const day0 = startOfDay(millis);
  const hour = 3_600_000;
  switch (shift) {
    case 'lunch':
      return { start: day0, end: day0 + SNACK_START_HOUR * hour };
    case 'snack':
      return { start: day0 + SNACK_START_HOUR * hour, end: day0 + DINNER_START_HOUR * hour };
    case 'dinner':
      return { start: day0 + DINNER_START_HOUR * hour, end: day0 + 24 * hour };
  }
}
